import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
// import MarkdownMessage from '@gluedigital/markdown-message'
import ClientSupport from 'src/components/Header/ClientSupport/ClientSupport'
import Loading from 'src/components/Loading/Loading'
import { useUserActions } from 'src/hooks/api'

import './Recover.sass'

const Recover = () => {
  const user = useSelector((s: any) => s?.user)

  const [email, setEmail] = useState(user?.email || '')
  const [status, setStatus] = useState('')
  const userActions = useUserActions()

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (status === 'loading') return
    setStatus('loading')
    try {
      await userActions.recoveryStart(email)
      setStatus('success')
    } catch (err) {
      console.warn(err)
      setStatus('error-other')
    }
  }

  const recoverForm =
    <form className={status} onSubmit={handleSubmit}>
      <h1><FormattedMessage id="recover.title" /></h1>
      <p><FormattedMessage id="recover.text" /></p>
      <label>
        <span className="icon icon-user" />
        <input
          required
          autoFocus
          placeholder="Email..."
          type="email"
          name="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
      </label>
      {
        status &&
          <p>
            <FormattedMessage id={`recover.${status}`} />
          </p>
      }
      <button className="filled" disabled={status === 'success'}>
        <FormattedMessage id="recover.send" />
      </button>
    </form>
  return (
    <div id="recover" className="page">
      <header id="recover-header">
        <ClientSupport />
      </header>
      <div className="split">
        <div className="item item-left" />
        <div className="item item-right">
          <div className="wrapper">
            <Link to="/" className="logo" />
            {status !== 'loading' ? recoverForm : <Loading />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Recover
